import { render, staticRenderFns } from "./PgaBusinessStartupCustomerOrderCreate.vue?vue&type=template&id=cecd9718&"
import script from "./PgaBusinessStartupCustomerOrderCreate.vue?vue&type=script&lang=ts&"
export * from "./PgaBusinessStartupCustomerOrderCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VCardTitle,VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader,VExpansionPanels,VForm})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cecd9718')) {
      api.createRecord('cecd9718', component.options)
    } else {
      api.reload('cecd9718', component.options)
    }
    module.hot.accept("./PgaBusinessStartupCustomerOrderCreate.vue?vue&type=template&id=cecd9718&", function () {
      api.rerender('cecd9718', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/business-startups/customer-orders/components/create/PgaBusinessStartupCustomerOrderCreate.vue"
export default component.exports